const URL_TEXTCOLOR_OPTIONS_OF_DROPS = [
  {
    name: "drop#01",
    items: [
      {
        name: "BLACK",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_1_-_Black_coordinates.png?v=1738738830"
      },
      {
        name: "WHITE",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_1_-_White_Coordinates.png?v=1726650786"
      },
      {
        name: "YELLOW",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_1_-_Yellow_Coordinates.png?v=1726650785"
      },
      {
        name: "GREEN",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_1_-_Green_Coordinates.png?v=1726650785"
      },
      {
        name: "ORANGE",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_1_-_Orange_Coordinates.png?v=1726650785"
      },
      {
        name: "PINK",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_1_-_Pink_Coordinates.png?v=1726650786"
      },
    ],
  },
  {
    name: "drop#02",
    items: [
      {
        name: "BLACK",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_2_-_Black_Coordinates.png?v=1738738845"
      },
      {
        name: "WHITE",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_2_-_WhiteCoordinates.png?v=1738738845"
      },
      {
        name: "PINK",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_2_-_Pink_Coordinates.png?v=1738738845"
      },
    ],
  },
  {
    "name": "drop#03",
    "items": [
      {
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_3_-_Black_Coordinates.png?v=1738738857",
        name: "BLACK"
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_3_-_White_Coordinates.png?v=1738738856",
        name: "WHITE"
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_3_-_Pink_Coordinates.png?v=1738738856",
        name: "PINK"
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_3_-_Orange_Coordinates.png?v=1738738856",
        name: "ORANGE"
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_3_-_Blue_Coordinates.png?v=1738738857",
        name: "LIGHT BLUE"
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Full_view_430x.png?v=1733155760",
        name: "DARK BLUE"
      }
    ]
  },
  {
    "name": "shirt",
    "items": [
        {
            url: "https://cdn.shopify.com/s/files/1/0809/2074/0152/files/black_shirt_blue_bottle.png?v=1778576309",
            name: "shirt_BLACK_bottle_2300ml"
        },
        {
            url: "https://cdn.shopify.com/s/files/1/0809/2074/0152/files/black_shirt_black_bottle.png?v=1778576309",
            name: "shirt_BLACK_bottle_730ml"
        },
        {
            url: "https://cdn.shopify.com/s/files/1/0809/2074/0152/files/white_shirt_blue_bottle.png?v=1778576309",
            name: "shirt_WHITE_bottle_2300ml"
        },
        {
            url: "https://cdn.shopify.com/s/files/1/0809/2074/0152/files/white_shirt_black_bottle.png?v=1778576309",
            name: "shirt_WHITE_bottle_730ml"
        },
        {
            url: "https://cdn.shopify.com/s/files/1/0809/2074/0152/files/White_T-shirt.png?v=1778576309",
            name: "shirt_WHITE"
        },
        {
            url: "https://cdn.shopify.com/s/files/1/0809/2074/0152/files/Black_T-shirt.png?v=1778576309",
            name: "shirt_BLACK"
        },
    ]
  }
];
